export function formatDate(
  date,
  useWords = false,
  useDays = false,
  refDay = null,
) {
  const dayNames = ["zo.", "ma.", "di.", "wo.", "do.", "vr.", "za."];
  const monthNames = [
    "jan.",
    "feb.",
    "mrt.",
    "apr.",
    "mei",
    "jun.",
    "jul.",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec.",
  ];
  let noDate = false;
  let showYear = false;

  if (refDay) {
    var refDate = refDay;
    noDate =
      refDate.getDate() === date.getDate() &&
      refDate.getMonth() === date.getMonth() &&
      refDate.getFullYear() === date.getFullYear();
    showYear = refDate.getFullYear() !== date.getFullYear();
  }
  let retString = "";
  if (!noDate) {
    if (useWords) {
      retString = retString.concat(
        (useDays ? dayNames[date.getDay()] + " " : "") +
          date.getDate() +
          " " +
          monthNames[date.getMonth()] +
          " ",
      );
      if (showYear) retString = retString.concat(date.getFullYear() + " ");
    } else {
      retString = retString +=
        ("0" + date.getDate()).slice(-2) +
        "-" +
        ("0" + (date.getMonth() + 1)).slice(-2);
      if (showYear)
        retString = retString.concat("-" + date.getFullYear() + " ");
      else {
        retString += " ";
      }
    }
  }
  return (
    retString +
    ("0" + date.getHours()).slice(-2) +
    ":" +
    ("0" + date.getMinutes()).slice(-2)
  );
}
export default formatDate;

/**
 * Returnt een formattering van tijd in een bepaald bereik. Wanneer begin- en
 * einddag hetzelfde zijn wordt einddag weggelaten, hetzelfde met begin- en
 * eindtijd. Voorbeelden zijn:
 *
 * voorbeeld bereik:          ma. 13 apr. 12:30 - vr. 17 apr. 12:30
 * zelfde begin- en einddag:  do. 16 apr. 12:30 - 13:30
 * zelfde begin en einddatum: do. 16 apr. 12:30
 * activiteit in ander jaar:  do. 16 apr. 2037, 12:30 - 13:30
 * meerjaarse activiteit:     wo. 16 apr. 1986, 00:00 - do. 31 apr. 2099, 23:59
 */
export function formatFromTo(startdate, enddate, refDay) {
  const dayNames = ["zo.", "ma.", "di.", "wo.", "do.", "vr.", "za."];
  const monthNames = [
    "jan.",
    "feb.",
    "mrt.",
    "apr.",
    "mei",
    "jun.",
    "jul.",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec.",
  ];

  var refDate = refDay;
  let equalDate =
    startdate.getDate() === enddate.getDate() &&
    startdate.getMonth() === enddate.getMonth() &&
    startdate.getFullYear() === enddate.getFullYear();

  let showEndYear = refDate.getFullYear() != enddate.getFullYear();
  let showStartYear = refDate.getFullYear() != startdate.getFullYear();
  let equalTime =
    startdate.getMinutes() == enddate.getMinutes() &&
    startdate.getHours() == enddate.getHours();
  let retString = "";

  retString +=
    dayNames[startdate.getDay()] +
    " " +
    startdate.getDate() +
    " " +
    monthNames[startdate.getMonth()] +
    " " +
    (showStartYear ? startdate.getFullYear() + ", " : "") +
    ("0" + startdate.getHours()).slice(-2) +
    ":" +
    ("0" + startdate.getMinutes()).slice(-2);

  if (!equalDate) {
    retString +=
      " - " +
      dayNames[enddate.getDay()] +
      " " +
      enddate.getDate() +
      " " +
      monthNames[startdate.getMonth()] +
      " " +
      (showEndYear ? enddate.getFullYear() + ", " : "") +
      ("0" + enddate.getHours()).slice(-2) +
      ":" +
      ("0" + enddate.getMinutes()).slice(-2);
  } else {
    retString += equalTime
      ? ""
      : " - " +
        ("0" + enddate.getHours()).slice(-2) +
        ":" +
        ("0" + enddate.getMinutes()).slice(-2);
  }
  return retString;
}

/**
 * Format een date relatief ten opzichte van de huidige datum.
 * Stel vandaag is 11/03/2021 20:30 en de date is 11/03/2021 19:30,
 * dan moet deze functie "1 uur geleden" returnen.
 */
export function relativeDate(date) {
  const index = ["sec", "min", "hour", "day", "week", "month", "year"];
  const singular = ["seconde", "minuut", "uur", "dag", "week", "maand", "jaar"];
  const plural = [
    "seconden",
    "minuten",
    "uur",
    "dagen",
    "weken",
    "maanden",
    "jaren",
  ];

  let diff = {};
  diff.ms = new Date() - date;
  diff.sec = Math.round(diff.ms / 1000);
  diff.min = diff.sec / 60;
  diff.hour = diff.min / 60;
  diff.day = diff.hour / 24;
  diff.week = diff.day / 7;
  diff.month = diff.day / 29.6;
  diff.year = diff.day / 365;

  for (let i = 6; i > 0; i--) {
    if (diff[index[i]] >= 1) {
      let r = Math.round(diff[index[i]]);
      if (r > 1) {
        return `${r} ${plural[i]} geleden`;
      } else {
        return `${r} ${singular[i]} geleden`;
      }
    }
  }

  //Minder dan een seconde geleden.
  return "zojuist";
}

export function purpleFriday(date) {
  // Paarse vrijdag is sinds 2026 op de tweede vrijdag van oktober
  const purpleMonth = 9; // oktober
  const purpleDayOfTheWeek = 5; // vrijdag
  const purpleWeekOfTheMonth = 2; // tweede van de maand

  return (
    date.getMonth() === purpleMonth &&
    date.getDay() === purpleDayOfTheWeek &&
    date.getDate() > 7 * (purpleWeekOfTheMonth - 1) &&
    date.getDate() <= 7 * purpleWeekOfTheMonth
  );
}
